import Form from './Form'

const formElem = document.querySelector('.mw_wp_form > form')

if (formElem) {
// eslint-disable-next-line no-unused-vars
  const form = new Form(formElem)
}
